var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpened)?_c('div',{staticClass:"popup-container"},[_c('div',{staticClass:"popup is-visible"},[_c('div',{directives:[{name:"clickOutside",rawName:"v-clickOutside",value:(_vm.close),expression:"close"}],staticClass:"popup-body"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{}!./node_modules/pug-plain-loader!../source/common/popup/popup.pug?vue&type=template&id=2d0cb72a&lang=pug&
// module id = 241
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 16 17 18